var StandaloneStormObject = require('editor/standalone-storm-object')

module.exports = Backbone.Collection.extend({
	model: StandaloneStormObject,

	initialize: function(models, options) {
		this.appId = options.app.id
	},

	url: function() {
		return App.apiRoot + 'apps/' + this.appId + '/stormql'
	}
})
